<nz-modal [nzVisible]="true" nzTitle="Assign Ticket to Agent" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" [nzOkLoading]="loading">
	<div *nzModalContent>
		<div nz-row [nzGutter]="16">
			<div nz-col [nzSpan]="6">
				<label for="agentSelect">Select Agent:</label>
			</div>
			<div nz-col [nzSpan]="18">
				<nz-select id="agentSelect" nzShowSearch nzAllowClear class="w-full" style="width:100%" [(ngModel)]="selectedAgent" nzPlaceHolder="Select an agent">
					<nz-option *ngFor="let agent of agents" [nzValue]="agent" [nzLabel]="agent.firstName + ' ' + agent.lastName">
					</nz-option>
				</nz-select>
			</div>
		</div>
	</div>
</nz-modal>
